var values = new Set(["normal", "nowrap"]);
export default (function (_a) {
    var whiteSpace = _a.whiteSpace;
    return values.has(whiteSpace) && "white-space: " + whiteSpace + ";";
});
